import React from 'react';
import PropTypes from 'prop-types';
import assets from "../../util/assets";
import {Button, Col} from "reactstrap";
import "./index.css";

EmptyComponent.propTypes = {
    img: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    btnText: PropTypes.string,
    btnAction: PropTypes.func,
};

function EmptyComponent(props) {
    return (
        <Col sm="12" className="bg-white p-3 mb-3 rounded" style={props.style}>
            <div className="home-container-empty-full-screen">
                <img
                    src={props.img}
                    alt={props.title}
                    width={"50%"}
                />
                <h4 style={{fontWeight: "bold", marginTop: 20}}>
                    {props.title}
                </h4>
                <p style={{margin: "0% 20%"}}>
                    {props.description}
                </p>
                {
                    props.btnAction  &&
                    <Button style={{width:240}} color="primary" className="my-library-empty-state-action" onClick={props.btnAction}>{props.btnText}</Button>
                }
            </div>
        </Col>
    );
}

export default EmptyComponent;